module.exports = __webpack_public_path__ + "images/emoji/black_square_button.d1a44324ccda9b7224bc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_square_button.png
// module id = vi1e
// module chunks = 14